import React from "react";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import StatusTab from "./Status/StatusTab";
import PriorityTab from "./Priority/PriorityTab";
import SeverityTab from "./Severity/SeverityTab";
// import RoleOptions from "./RoleOptions";
import Designations from "./Designations";
import Departmets from "./Departments";
import Skills from "./Skills";
import AwardsTab from "./Awards/AwardsTab";


function MasterTab() {
  const location = useLocation();

  // Check if Status or Priority is active
  const isActiveTab = (path) => location.pathname.includes(path);

  return (
    <div className="bg-white p-3 detailpage">
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item pe-4" role="presentation">
          <Link
            to="Status"
            className={`nav-link ${isActiveTab("Status") ? "active" : ""}`}
          >
            Status
          </Link>
        </li>
        <li className="nav-item pe-4" role="presentation">
          <Link
            to="Priority"
            className={`nav-link ${isActiveTab("Priority") ? "active" : ""}`}
          >
            Priority
          </Link>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <Link
            to="Severity"
            className={`nav-link ${isActiveTab("Severity") ? "active" : ""}`}
          >
            Severity
          </Link>
        </li>
        <li className="nav-item pe-4" role="presentation">
          <Link
            to="designations"
            className={`nav-link ${isActiveTab("designations") ? "active" : ""
              }`}
          >
            Designations
          </Link>
        </li>
        <li className="nav-item pe-4" role="presentation">
          <Link
            to="departments"
            className={`nav-link ${isActiveTab("departments") ? "active" : ""}`}
          >
            Departments
          </Link>
        </li>
        <li className="nav-item pe-4" role="presentation">
          <Link
            to="skills"
            className={`nav-link ${isActiveTab("skills") ? "active" : ""}`}
          >
            Skills
          </Link>
        </li>
        {/* Awards tab */}
        <li className="nav-item pe-4" role="presentation">
          <Link
            to="awards"
            className={`nav-link ${isActiveTab("awards") ? "active" : ""}`}>
            Awards
          </Link>
        </li>
      </ul>

      {/* Redirect to Status by default */}
      <Routes>
        <Route path="/" element={<Navigate to="Status" replace />} />
        <Route path="Status" element={<StatusTab />} />
        <Route path="Priority" element={<PriorityTab />} />
        <Route path="designations" element={<Designations />} />
        <Route path="departments" element={<Departmets />} />
        <Route path="skills" element={<Skills />} />
        <Route path="awards" element={<AwardsTab />} />
        <Route path="Severity" element={<SeverityTab />} />
      </Routes>
    </div>
  );
}

export default MasterTab;
